// extracted by mini-css-extract-plugin
module.exports = {"successContainer":"successContainer__3HjHZ","header":"header__14aN_","message":"message__3JXrj","buttonContainer":"buttonContainer__3loNI","email":"email__2V5l3"};